import { render, staticRenderFns } from "./wendang_new.vue?vue&type=template&id=41d4a348&scoped=true&"
import script from "./wendang_new.vue?vue&type=script&lang=js&"
export * from "./wendang_new.vue?vue&type=script&lang=js&"
import style0 from "./wendang_new.vue?vue&type=style&index=0&id=41d4a348&lang=scss&scoped=scoped&"
import style1 from "./wendang_new.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d4a348",
  null
  
)

export default component.exports